import { RefObject, useEffect } from 'react'

import { fastdom } from 'utils/fastdom'

/**
 *
 * @param ref element ref
 * @param _isOpen default open and toggle open state when this changes
 */
const useAnimatedHeightToggle = (
  ref: RefObject<HTMLElement>,
  _isOpen = false,
) => {
  useEffect(() => {
    if (!ref.current) {
      return
    }

    fastdom.mutate(() => {
      if (!ref.current) return
      ref.current.style.transition = 'all 200ms ease-out'
      ref.current.style.overflow = 'hidden'
    })

    const setContentHeightToMax = () => {
      fastdom.mutate(() => {
        if (ref.current) {
          ref.current.style.height = ref.current.scrollHeight + 'px'
          ref.current.style.opacity = '1'
        }
      })
    }

    const setContentHeightToZero = () => {
      fastdom.mutate(() => {
        if (ref.current) {
          ref.current.style.height = '0px'
          ref.current.style.opacity = '0.2'
        }
      })
    }

    if (_isOpen) {
      setContentHeightToMax()
    } else {
      setContentHeightToZero()
    }
  }, [_isOpen])
}

export { useAnimatedHeightToggle }
